function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".efa72bbc-b194-48b3-b952-e82858cd300e{fill:#6fc6dd;}.ebd5f955-7d17-4271-a778-d8ac12b9c347{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:4px;}.b9d05dc8-4198-4b13-83a6-007b49e6cd3f{opacity:0.3;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "efa72bbc-b194-48b3-b952-e82858cd300e",
  y: 155.74,
  width: 138.71,
  height: 138.71,
  rx: 13.43
});

var _ref4 = /*#__PURE__*/React.createElement("polyline", {
  className: "ebd5f955-7d17-4271-a778-d8ac12b9c347",
  points: "61.03 209.13 44.4 225.77 61.03 242.41"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "ebd5f955-7d17-4271-a778-d8ac12b9c347",
  x1: 44.4,
  y1: 225.77,
  x2: 98.48,
  y2: 225.77
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "b9d05dc8-4198-4b13-83a6-007b49e6cd3f"
}, /*#__PURE__*/React.createElement("rect", {
  className: "efa72bbc-b194-48b3-b952-e82858cd300e",
  x: 155.95,
  y: 155.74,
  width: 138.71,
  height: 138.71,
  rx: 13.43,
  transform: "translate(0.21 450.4) rotate(-90)"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "ebd5f955-7d17-4271-a778-d8ac12b9c347",
  points: "209.34 233.42 225.98 250.05 242.62 233.42"
}), /*#__PURE__*/React.createElement("line", {
  className: "ebd5f955-7d17-4271-a778-d8ac12b9c347",
  x1: 225.98,
  y1: 250.05,
  x2: 225.98,
  y2: 195.97
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "b9d05dc8-4198-4b13-83a6-007b49e6cd3f"
}, /*#__PURE__*/React.createElement("rect", {
  className: "efa72bbc-b194-48b3-b952-e82858cd300e",
  x: 155.95,
  width: 138.71,
  height: 138.71,
  rx: 13.43,
  transform: "translate(294.66 -155.95) rotate(90)"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "ebd5f955-7d17-4271-a778-d8ac12b9c347",
  points: "241.27 61.03 224.63 44.4 207.99 61.03"
}), /*#__PURE__*/React.createElement("line", {
  className: "ebd5f955-7d17-4271-a778-d8ac12b9c347",
  x1: 224.63,
  y1: 44.4,
  x2: 224.63,
  y2: 98.48
}));

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "efa72bbc-b194-48b3-b952-e82858cd300e",
  x: 311.9,
  y: 155.74,
  width: 138.71,
  height: 138.71,
  rx: 13.43,
  transform: "translate(762.5 450.19) rotate(180)"
});

var _ref9 = /*#__PURE__*/React.createElement("polyline", {
  className: "ebd5f955-7d17-4271-a778-d8ac12b9c347",
  points: "389.57 241.06 406.21 224.42 389.57 207.78"
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  className: "ebd5f955-7d17-4271-a778-d8ac12b9c347",
  x1: 406.21,
  y1: 224.42,
  x2: 352.13,
  y2: 224.42
});

function SvgControls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bd4cbd31-cc28-4bae-91e7-0881ce25eae5",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450.61 294.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControls);
export default __webpack_public_path__ + "static/media/controls.704fdd6c.svg";
export { ForwardRef as ReactComponent };